import { transformI18n } from "@/plugins/i18n";
import { mergeDefaultStateToPageState } from "@/utils/common";
import { ElMessage, ElMessageBox } from "element-plus";
import { onBeforeMount, onActivated, toRef } from "vue";
const useList = (props: any, func = {}) => {
  const defaultOptions = {
    getListApi: "", // 列表请求方法
    onLoad: "", // 数据加载完毕的回调方法
    deleteIsBatch: false, // 删除是否可以多选
    deleteIsBatchKey: "id", // 删除标识字段
    dataForm: {}, // 查询参数
    dataList: [], // 列表数据
    // order: '', // 列表排序参数
    // orderField: '', // 列表排序依据字段
    pageNum: 1, // 初始分页
    pageSize: 10, // 初始分页大小
    total: 0, // 页面总数居
    dataListLoading: false, // 是否处于获取数据状态
    dataListSelections: [], // 勾选页面数据
    addOrUpdateVisible: false, // 新增弹窗
    addOrUpdate: {}, // 弹窗对象
    actionList: [], // 弹窗对象
    needActiveQuery: true, // 是否需要主动查询
    firstLoading: true, // 是否第一次加载
    firstLoadingDone: false, // 第一次加载完毕
    initSelectRowId: "", // 进入页面默认选择
    localSingleSelection: {},
    cacheQuery: false, //组件缓存，激活时查询,
    showSearch: true, // 是否显示搜索框
  };
  const state = toRef(mergeDefaultStateToPageState(defaultOptions, props));
  const viewFns = {
    getParams() {
      return {
        pageNum: state.value.pageNum,
        pageSize: state.value.pageSize,
        ...state.value.dataForm,
      };
    },
    ...func,
    // 获取数据列表
    async query(pageNum = state.value.pageNum) {
      if (!state.value.getListApi || state.value.doNotQueryAutomatically) {
        return;
      }
      // 查询时 重置分页
      if (Number(pageNum)) {
        state.value.pageNum = pageNum;
      }
      // 第一次加载时，不显示loading
      if (!state.value.firstLoading) {
        state.value.dataListLoading = true;
      }

      let params = viewFns.getParams();
      if (state.value.formatParams) {
        params = state.value.formatParams(params);
      }
      try {
        const res = await state.value.getListApi(params);
        if (res?.status == "success" || res?.code == 200) {
          if (!res.rows) {
            state.value.dataList = [];
            return;
          }

          state.value.total = Number(res?.count || res?.total) || 0;
          // state.value.pageNum =  state.value.pageNum;
          // state.value.pageSize = res.data.pageSize;

          state.value.dataList = res.rows || [];
          if (state.value.onLoad) {
            state.value.onLoad(res, state);
          }
        } else {
          ElMessage.error(res.message);
        }
      } catch (e) {
      } finally {
        state.value.firstLoadingDone = true;
        state.value.key++;
        setTimeout(() => {
          state.value.dataListLoading = false;
        }, 300);
      }
    },
    refreshList() {
      state.value.pageSize = 10;
      state.value.pageNum = 1;
      viewFns.query();
    },
    handleCurrentChange(val: number) {
      state.value.pageNum = val;
      viewFns.query(val);
    },
    handleSizeChange(val: number) {
      state.value.pageNum = 1;
      state.value.pageSize = val;
      viewFns.query();
    },

    async operationHandle(item: any, row: any): Promise<void> {
      if (
        item.type === "delete" ||
        item.type === "confirm" ||
        item.name === transformI18n("common.delete")
      ) {
        ElMessageBox.confirm(
          `${transformI18n(item?.tip || transformI18n("common.deleteTip"))}`,
          transformI18n(transformI18n("common.tip")),
          {
            confirmButtonText: transformI18n("common.confirm"),
            cancelButtonText: transformI18n("common.cancel"),
            type: "warning",
          },
        )
          .then(async () => {
            await item.methods(row);
            viewFns.query(state.value.currentPage || state.value.pageNum);
          })
          .catch(() => {});
      } else {
        item.methods(row);
      }
    },
  };

  onBeforeMount(async () => {
    if (!state.value.firstLoadingDone) {
      await viewFns.query();
      state.value.firstLoading = false;
    }
  });
  // 缓存的组件，激活时，需要主动查询
  onActivated(async () => {
    if (state.value.cacheQuery && state.value.firstLoadingDone) {
      await viewFns.query(state.value.pageNum);
    }
  });
  return {
    state,
    ...viewFns,
    ...func,
  };
};

export default useList;
